import {http} from '../../utils/network.js'

export default {
	getTokenByCode: http('suoha/login/v2.0.0/h5_code_2_token', 'get'),
	getBkInfoByName:  http('suoha/bk_bond/bk_info_by_name', 'get'),
	getBondListByBk:  http('suoha/bk_bond/bond_list_by_bk', 'get'),
	getBkInfoList:  http('suoha/bk_bond/bk_info_list', 'get'),
	getBondInfo: http('suoha/bk_bond/bond_info', 'get'),
	getStockInfo: http('suoha/bk_bond/stock_info', 'get'),
	getBondAdjust: http('suoha/bond_info/adjust', 'get'),
	getBondIndustryList: http('suoha/bond_info/industry_bond_list', 'get'),
	getBondIndustryStat: http('suoha/bond_info/industry_stat', 'get'),
	getBondRedeem: http('suoha/bond_info/redeem', 'get'),
	getBondPut: http('suoha/bond_info/bond_put', 'get'),
	getBondMarketstat: http('suoha/suoha/bondmarketstat/list', 'get'),
	getSubNewList: http('suoha/bond_sub_new/bond_list', 'get'),
	getBondIssue: http('suoha/bond_info/bond_issue', 'get'),
	getBondFactor: http('suoha/bondfactor/list', 'get'),
	getQuantFactor: http('suoha/v1.0.0/factor_list', 'get'),
	getStockQuantFactor: http('suoha/v1.0.0/stock/filter_factor_list', 'get'),
	getEtfQuantFactor: http('suoha/v1.0.0/etf/filter_factor_list', 'get'),
	getBondBkInfoList: http('suoha/bk_bond/bond_bk_info_list', 'get'),
	getBondHolderList: http('suoha/bond_sub_new/bond_holder_list', 'get'),
	getIndexInfoList: http('suoha/indexinfo/list', 'get'),
	getSwindustryinfo: http('suoha/swindustryinfo/list', 'get'),
	getRealTime: http('suoha/data_info/real_time', 'get'),
	getMarketData: http('suoha/fund/qdii/market_data', 'get'),
	getDdiiInfo: http('suoha/fund/qdii/info/', 'get'),
	getDailyData: http('suoha/fund/qdii/daily_data', 'get'),
	login: http('suoha/login/v1.0.0', 'post'),
	setUserInfo: http('suoha/login/v1.0.0/completeInfo', 'post'),
	getUserInfo: http('suoha/user/v1.0.0/user_info', 'get'),
	addBoodToList: http('suoha/user/v1.0.0/user_self_select/select', 'post'),
	removeBoodToList: http('suoha/user/v1.0.0/user_self_select/delete', 'post'),
	userBoodCustomList: http('suoha/user/v1.0.0/user_self_select/bond_list', 'get'),
	userBoodCustomListV2: http('suoha/user/v1.0.0/user_self_select/bond_list_v2', 'get'),
	getCosSts: http('suoha/auth/cos_sts', 'get'),
	updateUserAvatarNickName: http('suoha/login/v1.0.0/update_info', 'post'),
	getIndexPeriodList: http('suoha/indexinfo/index_period_list', 'get'),
	getIndexYearList: http('suoha/indexinfo/index_year_list', 'get'),
	getRealTime: http('suoha/data_info/real_time', 'get'),
	getBondMarketInfo: http('suoha/bond_market/bond_market_info', 'get'),
	getStockMarketInfo: http('suoha/bond_market/stock_market_info', 'get'),
	getBondTopTenList: http('suoha/bond_info/bond_top10_param', 'get'),
	getBondTopTenDetail: http('suoha/bond_info/bond_top10_holders', 'get'),
	getIncomeData: http('suoha/fund/index_fund/return_stat', 'get'),
	getValuationData: http('suoha/fund/index_fund/value_stat', 'get'),
	getTopBottomData: http('suoha/fund/index_fund/top_bottom_stat', 'get'),
	getFundDetail: http('suoha/fund/index_fund/detail', 'get'),
	getLofDetail: http('suoha/lof/detail', 'get'),
	getOrderList: http('/suoha/user/v1.0.0/user_order/list', 'get'),
	createOrder: http('suoha/pay/createOrder', 'post'),
	prepay: http('suoha/pay/prepay', 'get'),
	getDiscountCodeExchange: http('suoha/share/v1.0.0/discount_code_exchange', 'get'),
	getSellItemList: http('suoha/share/v1.0.0/sell_page_item_list', 'get'),
	getSellItemById: http('suoha/share/v1.0.0/sell_page_item', 'get'),
	getSellItemListByUser: http('suoha/share/v1.0.0/sell_page_item_list/by_user', 'get'),
	queryOrder: http('suoha/pay/queryOrder', 'get'),
	getTopBottomStat: http('suoha/user/v1.0.0/user_self_select/top_bottom_stat', 'get'),
	getValueStat: http('suoha/user/v1.0.0/user_self_select/value_stat', 'get'),
	getReturnStat: http('suoha/user/v1.0.0/user_self_select/return_stat', 'get'),
	getDistributerList: http('suoha/user/v1.0.0/user_distr_order_list', 'get'),
	getNotifyStatus: http('suoha/wx/wxMsgSwitch/list', 'get'),
	updateNotifyStatus: http('suoha/wx/wxMsgSwitch/update', 'post'),
	getBondList: http('suoha/bond_info/bond_code_name_pairs', 'get'),
	getIndexMarketInfo: http('suoha/indexinfo/index_market_info', 'get'),// 指数基金 收盘点位
	getIndexFundMonthlySummary: http('suoha/indexinfo/monthly_summary', 'get'),// 指数基金 月度统计
	getIndustryMarketInfo: http('suoha/fund/index_fund/index_market_info', 'get'),// 基金详情 收盘点位
	getFundMonthlySummary: http('suoha/fund/index_fund/monthly_summary', 'get'),// 基金详情 月度统计
	createUserGroup: http('suoha/user/v1.0.0/user_self_select/add_group', 'post'),// 用户新增分组
	updateUserGroup: http('suoha/user/v1.0.0/user_self_select/update_group', 'post'),// 用户编辑分组
	getUserGroupList: http('suoha/user/v1.0.0/user_self_select/group_list', 'get'),// 获取用户分组
	deleteUserGroup: ({ url }) => http(url, 'delete'),// 删除用户分组
	// 股债性价比
	getIndexFedDataList: http('suoha/index_fundamental/fed_data_list', 'get'),
	getIndexFedIndex: http('suoha/index_fundamental/fed_index', 'get'),
	// PE/PB bands
	getIndexBonds: http('suoha/index_fundamental/data_bonds', 'get'),
	getIndexBondsLevel: http('suoha/index_fundamental/data_bonds_5_level', 'get'),
	// 国债利差
	getNationalDebtYield: http('suoha/index_fundamental/national_debt_yield_spread', 'get'),
	// 回测基金查询
	getFundByKeyWord: http('strategy/symbol/query-fund-symbol', 'get'),
	// 基金再平衡策略回测
	rebalancingBacktest: http('strategy/fund/rebalancing-backtest', 'post'),
	// 保存再平衡参数
	saveBacktest: http('strategy/backtest/save', 'post'),
	// 批量查询基金代码
	batchFundByKeyWord: http('strategy/symbol/batch-query-fund-symbol', 'post'),
	// 查询回测详情
	getBackTestDetail: http('strategy/backtest/detail', 'get'),
	// 查询回测列表
	getBackTestList: http('strategy/backtest/list?page=1&pageSize=1000', 'post'),
	// 量化回测
	getQuantBackTestList: http('strategy/backtest/list?page=1&pageSize=1000&backtest_type=2', 'post'),
	// 股票量化回测
	getQuantStockBackTestList: http('strategy/backtest/list?page=1&pageSize=1000&backtest_type=3', 'post'),
	// ETF 量化回测（backtest_type 与接口路径请按后端约定调整）
	getQuantEtfBackTestList: http('strategy/backtest/list?page=1&pageSize=1000&backtest_type=4', 'post'),
	// 查询回测详情
	getBackTestDetail: http('strategy/backtest/detail', 'get'),
	// qd详情估值列表
	getQdInfoList: http('suoha/fund/qdii/market_data_one?', 'get'),
	// 广告
	getAdList: http('suoha/user/v1.0.0/banner/list', 'get'),
	// 下修记录
	getBondAdjLog: http('suoha/bk_bond/bond_adj_log', 'get'),
	// 指数基金收益列表
	getIndexFundV2: http('suoha/indexinfo/return_stat', 'get'),
	// 指数基金估值列表
	getIndexFundValueV2: http('suoha/indexinfo/value_stat', 'get'),
	// 指数基金顶底列表
	getIndexFundTopBottomV2: http('suoha/indexinfo/top_bottom_stat', 'get'),
	// 指数基金详情
	getIndexFundDetailV2: http('suoha/indexinfo/detail', 'get'),
	// 指数基金成分股
	getIndexConstituentStocks: http('suoha/indexinfo/index_stock_weight', 'get'),
	// 指数基金成收益统计
	getIndexIncomeData: http('suoha/fund/index_fund/v2.0/return_stat', 'get'),
	// 指数基金顶底统计
	getIndexTopBottomData: http('suoha/fund/index_fund/v2.0/top_bottom_stat', 'get'),
	// 指数名称 基金名称 基金代码 搜索
	getSearchFundList: http('suoha/login/v2.0.0/searchComplex', 'get'),
	// 控制Tabbar显示隐藏
	getTabbarShow: http('suoha/data_info/mini_pro_version', 'get'),
	// 微信jssdk
	getJsTicket: http('suoha/login/v2.0.0/js_api_info', 'get'),
	// 多因子回测
	runMultiFactorBacktest: http('strategy/bond/multiple-factor-backtest', 'post'),
	// 分段统计
	getMultiAnalyse: http('strategy/bond/ranking-analysis', 'post'),
	// 保存回测策略
	saveBacktestStrategy: http('strategy/backtest/save', 'post'),
	// 删除回测策略
	deleteBacktestStrategy: http('strategy/backtest/delete', 'post'),
	// 获取策略列表
	getStrategyList: http('suoha/v1.0.0/rotation_strategy/list', 'post'),
	// 删除策略
	deleteStrategy: http('suoha/v1.0.0/rotation_strategy/delete', 'delete'),
	// 获取策略详情
	getStrategyDetail: http('suoha/v1.0.0/rotation_strategy/detail', 'get'),
	// 计算选债列表
	getSelectBondList: http('suoha/v1.0.0/rotation_strategy/calculate_bond_list', 'post'),
	getSelectStockList: http('suoha/v1.0.0/rotation_strategy/calculate_stock_list', 'post'),
	getSelectEtfList: http('suoha/v1.0.0/rotation_strategy/calculate_etf_list', 'post'),
	// 获取策略调仓记录
	saveStrategy: http('suoha/v1.0.0/rotation_strategy/add', 'post'),
	// 更新策略
	updateStrategy: http('suoha/v1.0.0/rotation_strategy/update', 'post'),
	// 获取策略详情
	getRotationStrategyDetail: http('suoha/v1.0.0/rotation_strategy/get', 'get'),
	getRotationStrategyDetailByShareKey: http('suoha/v1.0.0/rotation_strategy/share/get', 'get'),
	// 获取调仓详情
	getRotationDetail: http('suoha/qmt/rotation/detail', 'get'),
	// 获取策略表现数据
	getStrategyPerformance: http('suoha/qmt_stat/info', 'get'),
	// 获取策略业绩数据
	getStrategyNavHistory: http('suoha/qmt_nav/history', 'get'),
	// 获取持仓详情数据
	getPositionDetails: http('suoha/v1.0.0/position/amount', 'get'),
	// 获取交易记录列表
	getTransactionList: http('suoha/v1.0.0/txn/page_list', 'get'),
	// 搜索交易代码
	searchTransactionCode: http('suoha/v1.0.0/search_code', 'get'),
	// 搜索股票代码
	searchStockCode: http('suoha/v1.0.0/search_code', 'get'),
	searchEtfCode: http('suoha/v1.0.0/search_code', 'get'),
	// 添加交易记录
	addTransactionRecord: http('suoha/v1.0.0/txn/update', 'post'),
	// 获取策略持仓详情列表
	getStrategyPositionList: http('suoha/v1.0.0/position/page_list', 'get'),
	getFilterFactorOptions: http('suoha/v1.0.0/stock/filter_factor_options', 'get'),
	// 获取策略基准列表
	getPeriodList: http('suoha/indexinfo/index_period_list', 'get'),
	// 股票量化回测
	runMultiFactorStockBacktest: http('strategy/astock-backtest/multiple-factor-backtest', 'post'),
	// ETF 量化回测（默认与股票并列的新路径，可按后端实际修改）
	runMultiFactorEtfBacktest: http('strategy/etf-backtest/multiple-factor-backtest', 'post'),
	// 批量查询股票
	batchQueryStockCode: http('suoha/v1.0.0/stock/batch_search_code', 'post'),
}